import { FC, ReactNode } from "react";
import { Dialog, Flex, Text } from "@chakra-ui/react";

import { CloseButton } from "@shared/components";
import { FONT_WEIGHT } from "@assets/theme/foundations/textStyle";

interface CaseDocumentModalHeaderProps {
  title: string;
  subtitle?: string;
  icon?: ReactNode;
  overline?: string;
}

const CaseDocumentModalHeader: FC<CaseDocumentModalHeaderProps> = ({ title, subtitle, icon, overline }) => (
  <Dialog.Header display="flex" alignItems="flex-start" gap="14px" pt={6} pr={14}>
    {icon}
    <Flex direction="column" gap="6px">
      {overline && (
        <Text fontSize="13px" fontWeight={FONT_WEIGHT.HEAVY} letterSpacing="0.1em" color="brand.emptyStateText">
          {overline}
        </Text>
      )}
      <Text textStyle="modalTitle" fontSize="22px" lineHeight={1.3}>
        {title}
      </Text>
      {subtitle && (
        <Text fontSize="14px" fontWeight="normal" lineHeight={1.5} color="brand.textSecondary">
          {subtitle}
        </Text>
      )}
    </Flex>
    <Dialog.CloseTrigger asChild top={5}>
      <CloseButton color="grey.10" />
    </Dialog.CloseTrigger>
  </Dialog.Header>
);

export default CaseDocumentModalHeader;
